import React, { FC, useEffect, useState } from 'react';
import { PointsProps } from './types';
import './styles/points.css';

export const Points: FC<PointsProps> = ({ home, opponents }) => {
    return (
        <div className='points'>
            <div>
                <p>{String(home).padStart(2, '0')}</p>
            </div>
            <div>
                <p>{String(opponents).padStart(2, '0')}</p>
            </div>
        </div>
    );
};
